module.exports = __webpack_public_path__ + "img/HereBeRecruiters.51ffe933.svg";